import { render, staticRenderFns } from "./SdsAceticAcid.vue?vue&type=template&id=24a47be3&scoped=true&"
import script from "./SdsAceticAcid.vue?vue&type=script&lang=js&"
export * from "./SdsAceticAcid.vue?vue&type=script&lang=js&"
import style0 from "./SdsAceticAcid.vue?vue&type=style&index=0&id=24a47be3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a47be3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup,VTextField})
